export const APP_NAME = 'Orizel';

export const FREQUENCIES = ['1', '7', '30', '120', '365'];
